/** "A", "A and B", "A, B and C"; an empty list reads as "". */
export const joinWithAnd = (items: string[]): string =>
  items.length < 2 ? (items[0] ?? '') : `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}`;
